import type {NamedSetState} from 'app/gemStore/devtools';

import type {NotificationBarSlice} from './types';

export const createNotificationBarSlice = (set: NamedSetState<NotificationBarSlice>) => ({
    notificationBar: false,
    openNotificationBar: () => set({notificationBar: true}, false, 'notificationBar/openNotificationBar'),
    closeNotificationBar: () => set({notificationBar: false}, false, 'notificationBar/closeNotificationBar'),
});
